export default __webpack_public_path__ + "static/public-search-0bacdc86fe7a3856f003862016e551e7.webp";